import { api } from '@/fsd/shared/api';

interface IParams {
  email: string;
}

interface IResult {
  challenge_id: string;
  expires_in: number;
}

export const authPasswordReset = async (data: IParams) => {
  const response = await api.post<{ data: IResult }>(
    '/api/v1/auth/password/reset/',
    {
      body: { ...data },
      notify: {
        error: true,
      },
    }
  );

  return response;
};
